var styles = {"root":"Step-module_root___TIbM","text":"Step-module_text__sbM7j"};

export { styles as default };
//# sourceMappingURL=Step.module.css.js.map
